export enum NodeViewMode {
  Single = 'single',
  Batch = 'batch',
  All = 'all',
}
